var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pat6"},[_c('div',{staticClass:"main"},[_c('h1',[_vm._v(_vm._s(_vm.projectData.projectName))]),_c('h1',[_vm._v("科普作品征集项目")]),_c('el-button',{on:{"click":function($event){return _vm.$router.push({path:'/UserCenter'})}}},[_vm._v("立即参与")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }